/* eslint-disable import/prefer-default-export */
import Matrix from './components/Matrix.react';

export {
    Matrix
};
